<ng-container [ngSwitch]="layout$ | async">
  <app-fresh-product-info-page *ngSwitchCase="layouts.Fresh"></app-fresh-product-info-page>
</ng-container>
